import { SupplierModelType } from '@teinor/erp/types/company/supplier'
import { BillingGroupSupplierRelModelType } from '@teinor/erp/types/company/config/billingGroup/billingGroupSupplierRel'
import { ComponentWithPermissions } from '../../../../../../../../baseComponents/CreateRoutering/types'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import React, { Fragment } from 'react'
import { AllReduxPayloads } from '../../../../../../../../utils/reducers'
import { connect, ConnectedProps } from 'react-redux'
import withLoading from '../../../../../../../../utils/hoc/withLoading'
import { BillingGroupPayload } from '../../../../../../../../utils/reducers/company/billingGroups'
import ModalCESupplierBillingGroupConnect from './ModalCESupplierBillingGroup'
import { permissionCheck } from '../../../../../../../../baseComponents/PermissionChecker/function'
import ModalDeleteSupplierBillingGroup from './ModalDeleteSupplierBillingGroup'
import BaseScreenTableInner from '../../../../../../../../baseComponents/TwinTable/BaseScreenTableInner'
import { TableComponentBaseScreenInnerProps } from '../../../../../../../../baseComponents/TwinTable/BaseScreenTableInner/types'
import { ColumnTableSchema } from '../../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { CustomRenderString, DeleteRow, EditRow } from '../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import TwinTable from '../../../../../../../../baseComponents/TwinTable'
import { RowData } from '../../../../../../../../baseComponents/TwinTable/types'

interface SupplierBillingGroupsProps extends ComponentWithPermissions {
    basicData: SupplierModelType | null
}

const SupplierBillingGroups: React.FC<SupplierBillingGroupsProps> = ({ basicData, userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('billingGroups', 'Grupos de facturación'),
        newText: t('addBillingGroup', 'Nuevo  grupo de facturación'),
    }

    return (
        <BaseScreenTableInner TableComponent={TableSupplierBillingGroupsConnect} DeleteModalComponent={ModalDeleteSupplierBillingGroup} CreateModalComponent={ModalCESupplierBillingGroupConnect} EditModalComponent={ModalCESupplierBillingGroupConnect} pageData={pageData} userPermissions={userPermissions} extraWhereParams={{ SupplierId: basicData?.id }} />
    )
}
type TableSupplierBillingGroupsProps = TableComponentBaseScreenInnerProps & ReduxSupplierBillingGroupsConnector & {}


const TableSupplierBillingGroups: React.FC<TableSupplierBillingGroupsProps> = ({ setTableInstance, billingGroups, extraWhereParams, setOpened, userPermissions }) => {
    const { t } = useTwinTranslation()
    const columns: ColumnTableSchema<BillingGroupSupplierRelModelType> = [
        {
            id: 'BillingGroupId',
            dataKey: 'BillingGroupId',
            label: t('billingGroup', 'Grupo de Facturación'),
            customRender: (paramterValue, allRowData) => <CustomRenderString value={allRowData?.BillingGroup?.name || ''} />,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('billingGroup', 'Grupo de Facturación'), }
            },
            searchKey: 'BillingGroup.name'
        },
        {
            id: 'BillingTypeBuyOptions',
            dataKey: 'BillingTypeBuyOptions',
            label: t('byDefault', 'Por defecto'),
            customRender: (parameterValue, allRowData) => <RenderBillingTypeBuyOptions allRowData={allRowData} billingGroups={billingGroups} />,
        },
        {
            id: 'edit',
            dataKey: 'BillingGroupId',
            label: '',
            width: 50,
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} />
        },
        {
            id: 'delete',
            dataKey: 'BillingGroupId',
            label: '',
            width: 50,
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTable columns={columns} name='SupplierBillingGroups' getDataFrom='/api/app/supplier/supplierBillingGroup/getAllBillingGroupsSuppliers' defaultOrder={{ defaultOrderField: 'BillingGroupId', order: 'asc' }}
            onRowClick={(_id, rowData) => setOpened({
                type: 'edit',
                allRowData: rowData
            })}
            setTableInstance={setTableInstance} extraWhereParams={extraWhereParams}
        />
    )
}
interface RenderBillingTypeBuyOptionsProps {
    billingGroups: BillingGroupPayload
    allRowData?: RowData
}

const RenderBillingTypeBuyOptions: React.FC<RenderBillingTypeBuyOptionsProps> = ({allRowData, billingGroups}) => {
    const billingTypesOptions = billingGroups?.billingTypesAllBuyOptions || {}
    let result: JSX.Element[] = []
    for (const value of allRowData?.BillingTypeBuyOptions) {
        const myBillingTypeOption = billingTypesOptions[value]
        if (myBillingTypeOption) {
            result.push(<span key={value} className='mr-5'>{myBillingTypeOption.code}</span>)
        }
    }
    return (<Fragment>{result}</Fragment>)
}


const tableSupplierBillingGroupsDispatch = {
    setBillingGroups: (payload: BillingGroupPayload) => ({ type: 'CHANGE_BILLINGGROUP', payload }),
}
const mapTableSupplierBillingGroupsConnector = (state: AllReduxPayloads) => ({ billingGroups: state.billingGroups })
const tableSupplierBillingGroupsConnector = connect(mapTableSupplierBillingGroupsConnector, tableSupplierBillingGroupsDispatch)
type ReduxSupplierBillingGroupsConnector = ConnectedProps<typeof tableSupplierBillingGroupsConnector>
const tableBuysConnectLoading = withLoading(TableSupplierBillingGroups, [{ fetchUrl: '/api/app/config/billingGroup/getAllBillingGroupsComplete', propName: 'billingGroups', setFunctionName: 'setBillingGroups' }])
const TableSupplierBillingGroupsConnect = tableSupplierBillingGroupsConnector(tableBuysConnectLoading)

export default SupplierBillingGroups